import Vue from 'vue'
import Component from 'vue-class-component'
import VideoTab from '../videoTab/videoTab'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop, Watch } from 'vue-property-decorator';
import { getQueryString } from '@/utils/location';
import { judgeDeviceType } from '@/utils/device';
import { changeUrl2Cdn } from '../../utils/utils';

@Component({
  components: {
    VideoTab
  }
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class GeneratePicture extends Vue {
  @Prop({default: []})
  imgList: Array<any>
  @Prop({default: []})
  textList: Array<any>
  @Prop({default: ''})
  taskId: string
  @Prop({default: 0})
  imgIndex:number
  @Prop({default: () => []})
  orginalImgList:any
  @Prop({default: ''})
  scaleRatio: string
  @Prop({default: {}})
  vipInfo: any

  imgUrl = 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
  galleryList = [
    {
      id: 0,
      url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    },
    {
      id: 1,
      url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    },
    {
      id: 2,
      url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    },
    {
      id: 3,
      url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    },
    {
      id: 4,
      url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    }
  ]
  // 当前被选择Item
  activeGalleryItemIndex = 0

  tabList = [
    {
      id: 0,
      name: '生图'
    },
    {
      id: 1,
      name: '微调'
    },
    {
      id: 2,
      name: '相册选取'
    }
  ]
  activeTab = this.tabList[0]
  // 描述
  emptyDescMap = {
    0: '基于上方选中的图片，进行图片重新生成，在此处展示结果',
    1: '敬请期待～',
    2: '敬请期待～'
  }
  // 生成图片
  generateImgList = [
    // {
    //   id: 0,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 1,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 2,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 3,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 4,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 5,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 6,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
    // {
    //   id: 7,
    //   url: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png'
    // },
  ]
  // 微调图片合集
  adjustmentImageList = []
  activeGenerateImg:any = {}
  activePromptImg:any = {}
  // 本次修改图片集合
  imgExchangeList = []
  inter = null
  // 生成图片
  generateBtnTextMap = {
    0: '生成图片',
    1: '继续生图',
    2: '生成中...'
  }
  generateBtnStatus = 0
  articleId: string = '-1'
  // prompt
  promptTxt = ''
  showPrompt = false
  isApp = judgeDeviceType.isAPP
  state = new PageState();
  originWindowH = 0;
  // 总次数
  currentReGenLimit = 0
  // 生成图片次数
  generateCurrentGenNum = 0;
  placeholder = '基于上方选中的图片，在文本框内描述想要的效果，点击生成图片获得基于上图的微调结果'
  get currImgInfo() {
		return this.imgList[this.activeGalleryItemIndex] || {}
	}
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted() {
    this.articleId = getQueryString('articleId')
    this.originWindowH = window.innerHeight;
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      // 图片画廊滚动到选中图片位置
      const activeDom = document.querySelector('.gallery-item-active') as HTMLElement;
      const offsetLeft = activeDom.offsetLeft;
      const galleryDom = this.$refs.galleryRef as HTMLElement;
      if(offsetLeft && galleryDom) {
        galleryDom.scrollLeft = offsetLeft;
      }
    })
    this.getReGenImageList()
  }
  destroy() {
    window.removeEventListener('resize', this.onResize);
  }
  onResize() {
    if (this.originWindowH !== window.innerHeight || document.activeElement?.nodeName === 'BODY') return;
    const textareaDom = this.$refs.textareaRef as HTMLTextAreaElement;
    if(textareaDom) {
      textareaDom.blur();
    }

  }
  vipMap = {
    0: '体验会员',
    1: '正式会员'
  }
  @Watch('imgIndex', {immediate: true})
  listenImgIndex(val) {
    this.activeGalleryItemIndex = val
    this.initImgList();
    this.promptTxt = ''; //切换图片时输入框清空
  }
  /**
   * 查询生成图片次数
   */
  getReGenImageList() {
    const params = {
      type: this.activeTab.id + 1,
      originImageId: this.currImgInfo.imageId,
    }
    this.$http('qryReGenImageList', params).then((res) => {
      if (res.code === 200) {
        const { composeImageNewVOList, correctImagePromptVOList, currentReGenLimit, currentReGenNum} = res.data
        this.currentReGenLimit = currentReGenLimit;
        this.generateCurrentGenNum = currentReGenLimit - currentReGenNum;
        this.placeholder = `基于上方选中的图片，进行图片重新生成，在此处展示结果，${this.vipMap[this.vipInfo.vipType]}每个作品可以更换${currentReGenLimit}次图`
      }
      console.log('getReGenImageList', res)
    })
  }
  /**
   * 切换item
   */
  changeGallery(item, index) {
    this.activeGalleryItemIndex = index
    this.activeGenerateImg = {}
    console.log('changeGallery', item)
    this.$emit('select-gallery', item, index, true)
    this.getReGenImageList()
    // this.getComposeImgList()
  }
  /**
   * 切换tab
   */
  changeTab(tab) {
    this.activeTab = tab
    this.initImgList();
  }
  // 初始化图片列表
  initImgList() {
    if(this.activeTab.id === 0) {
      this.getComposeImgList();
    } else if (this.activeTab.id === 1) {
      this.getGenerateAdjustmentList();
    }
  }
  // 重置
  reset() {
    this.imgExchangeList = [];
    this.$nextTick(() => {
      this.setActivedImg();
    })
  }
  // 设置选中
  setActivedImg() {
    this.activeGenerateImg = this.generateImgList.find(item => item.url ===  this.currImgInfo.imgUrl) || {}
    this.activePromptImg = this.adjustmentImageList.find(item => item.url ===  this.currImgInfo.imgUrl) || {};
  }
  /**
   * 切换选择生成图片
   */
  changeGenerateImg(imgInfo) {
    if (this.activeGenerateImg.id === imgInfo.id && this.activeGenerateImg.url === imgInfo.url) return
    console.log('changeGenerateImg', imgInfo)
    this.activeGenerateImg = imgInfo
    this.completeGenerate(imgInfo);
  }

  /**
   * 切换微调图片
   * @param imgInfo 
   * @returns 
   */
  changeAdjustmentImg(imgInfo) {
    if (this.activePromptImg.id === imgInfo.id  && this.activePromptImg.url === imgInfo.url) return
    this.activePromptImg = imgInfo
    this.completeGenerate(imgInfo);
  }
  promtEditFocus() {
    if (judgeDeviceType.isAndroid || judgeDeviceType.isAPP) {
      this.state.promtFocus = true
    }
    
  }
  promtEditBlur() {
    this.state.promtFocus = false
  }

  getComposeImgList() {
    this.$http('getQueryComposeImgList', {originImageId: this.currImgInfo.imageId})
      .then(res => {
        if (res.code === 200 && res.data) {
          this.generateImgList = res.data.map(item => {
            return {
              ...item,
              url: changeUrl2Cdn(item.url),
              thumbnailUrl: changeUrl2Cdn(item.thumbnailUrl)
            }
          })
          this.setActivedImg();
        }
      })
  }
  /**
   * 获取微调图片合集
   */
  getGenerateAdjustmentList() {
    this.$http('getAdjustmentList', {originImageId: this.currImgInfo.imageId})
      .then(res => {
        if (res.code === 200 && res.data) {
          this.adjustmentImageList = res.data.filter(item => item.id > 0).map(item => {
            return {
              ...item,
              url: changeUrl2Cdn(item.url),
              thumbnailUrl: changeUrl2Cdn(item.thumbnailUrl)
            }
          })
          if (this.adjustmentImageList.length) {
            this.showPrompt = false
            this.setActivedImg();
          } else {
            this.showPrompt = true
          }
        }
      })
  }
  /**
   * 清空promptTxt
   */
  clearPrompt() {
    this.promptTxt = ''
  }
  // 点击勾号完成时，进行接口调用
  async completeEdit() {
    await this.doExchangeList();
    this.closePopup();
  }
  closePopup() {
    this.$emit('close')
  }
  completeGenerate(selectedItem) {
    const { id, url, thumbnailUrl } = selectedItem;
    if (this.generateBtnStatus === 2) {
      this.$toast({
        message: '有图片生成中，请稍后'
      })
      return
    }
    if (!id) {
      this.$toast({
        message: 'id不存在'
      })
      return
    }
    const index = this.activeGalleryItemIndex
    const imgInfo = this.currImgInfo;
    // 设置修改列表
    const changeIndex = this.imgExchangeList.findIndex(img => img.currentImageId === imgInfo.imageId);
    if(changeIndex === -1) {
      this.imgExchangeList.push({
        currentImageId: imgInfo.imageId,
        targetImgUrl: url,
        targetThumbnailUrl: thumbnailUrl,
        originImgUrl: imgInfo.imgUrl, // 原图，用于比较和撤销操作
        originThumbnailUrl: imgInfo.thumbnailUrl, // 原缩略图
      });
    } else {
      const changeItem = this.imgExchangeList[changeIndex];
      if(changeItem.originImgUrl === url) {
        // 换成原图，删除这一条
        this.imgExchangeList.splice(changeItem, 1);
      } else {
        changeItem.targetImgUrl = url;
        changeItem.targetThumbnailUrl = thumbnailUrl;
      }
    }
    // 修改图片展示列表
    const newImgList = JSON.parse(JSON.stringify(this.imgList));
    newImgList[index].imgUrl = url;
    newImgList[index].thumbnailUrl = url;
    // this.$emit('select-gallery', newImgList[index], index);
    this.$emit('complete', newImgList, index);
  }
  doExchangeList() {
    if(!this.imgExchangeList.length) return;
    const params = {
      taskId: this.taskId,
      imgExchangeList: this.imgExchangeList
    }
    // 交换选中生图（或微调）和当前图片，不会更改图片id，而是交换图片地址
    return this.$http('batchExchangeImage',params).then((res) => {
      if (res.code === 200) {
        const promptImageVOList = res.data.promptImageVOList
        const imgList = this.imgList.map((item, i) => {
          const info = promptImageVOList[i];
          item.imgUrl = info.imageUrl;
          item.thumbnailUrl = info.thumbnailUrl;
          return item;
        })
        // console.log('completeGenerate', res.data.promptImageVOList)
        // this.changeGallery(imgList[this.activeGalleryItemIndex], this.activeGalleryItemIndex)
        // this.$emit('select-gallery', imgList[this.activeGalleryItemIndex], this.activeGalleryItemIndex)
        this.$emit('complete', imgList, this.activeGalleryItemIndex, this.imgExchangeList)
      } else {
        this.$toast(res.message || '图片修改失败');
        // this.$emit('select-gallery', this.orginalImgList[this.activeGalleryItemIndex], this.activeGalleryItemIndex);
        this.$emit('complete', this.orginalImgList, this.activeGalleryItemIndex)
      }
    })
    
  }
  previewImg(imgInfo) {
    console.log('previewImg', imgInfo)
    this.$navigateTo({
      url: `/baohuo-package/pages/picture-preview/picture-preview?imgUrl=${encodeURIComponent(imgInfo.url)}&scaleRatio=${this.scaleRatio}`,
    })
  }
  changeShowPrompt() {
    // if (!this.activePromptImg.id) {
    //   this.$toast('请选择一张图片')
    //   return
    // }
    // 都是相对于原图微调；未选中微调图片时，promptTxt为空即可
    this.showPrompt = true
    this.promptTxt = this.activePromptImg?.originalPrompt || ''
  }
  generateImg() {
    if (this.generateBtnStatus === 2) return
    // getRenewImageStatus
    const imageId = this.currImgInfo.imageId;
    if (this.generateCurrentGenNum <= 0) return
    if (this.activeTab.id === 1) {
      this.generateBtnStatus = 2
      this.$http('adjustmentGenerate', {
        id: imageId,
        prompt: this.promptTxt
      }).then(res => {
        if (res.code === 200) {
          this.checkGetAdjustmentStatus(res.data)
          this.inter = setInterval(() => {
            this.checkGetAdjustmentStatus(res.data)
          }, 3000)
        } else {
          this.$toast(res.message)
          this.generateBtnStatus = 0
        }
      }).catch(() => {
        this.generateBtnStatus = 0
      })
    } else {
      this.generateBtnStatus = 2
      this.$http('renewImg', {
        id: imageId,
      }).then(res => {
        if (res.code === 200) {
          this.checkGetRenewImageStatus(res.data)
          this.inter = setInterval(() => {
            this.checkGetRenewImageStatus(res.data)
          }, 3000)
        } else {
          this.$toast(res.message || '生图失败');
          this.generateBtnStatus = 0
        }
      }).catch(() => {
        this.generateBtnStatus = 0
      })
    }
    
  }
  /**
   * 返回到图集列表页
   */
  promtBack() {
    this.showPrompt = false
  }
  /**
   * 查询重新生图状态
   * @param id
   */
  checkGetRenewImageStatus(id) {
    this.$http('getRenewImageStatus', {id}).then(res => {
      if (res.code === 200) {
        if (res.data.complete === true) {
          clearInterval(this.inter)
          this.inter = null
          const composeImageNewVO = res.data.composeImageNewVO
          if (composeImageNewVO.status === 3) {
            this.generateBtnStatus = 0
            this.$toast('生图失败')
          } else {
            this.generateBtnStatus = 1
          
            this.generateImgList = [...this.generateImgList, {
              id: composeImageNewVO.id,
              asyncTaskId: composeImageNewVO.asyncTaskId,
              url: composeImageNewVO.url,
              originImageId: composeImageNewVO.originImageId
            }]
            this.getComposeImgList()
            this.getReGenImageList()
          }
          
        }
      } else {
        this.generateBtnStatus = 0
      }
    }).catch(() => {
      this.generateBtnStatus = 0
    })
  }
  /**
   * 查询重新生图状态
   * @param id 
   */
  checkGetAdjustmentStatus(id) {
    this.$http('adjustmentQueryStatus', {id}).then(res => {
      if (res.code === 200) {
        if (res.data.complete === true) {
          clearInterval(this.inter)
          this.inter = null
          const composeImageNewVO = res.data.correctImagePromptVO
          if (composeImageNewVO.status === 3) {
            this.generateBtnStatus = 0
            this.$toast('生图失败')
          } else {
            this.generateBtnStatus = 1
            this.adjustmentImageList = [...this.adjustmentImageList, composeImageNewVO]
            this.showPrompt = false
            this.getReGenImageList()
          }
        }
      } else {
        this.generateBtnStatus = 0
      }
    }).catch(() => {
      this.generateBtnStatus = 0
    })
  }
   
}